import { ServerFile } from '../ecg/types/ecg.type';
import { ServerWave } from '../wave/types/wave.type';

export interface ServerCluster {
  category_code: string;
  has_children: boolean;
  id: number;
  onsets_offsets: [
    number, // the onset of the beat
    number, // the offset of the beat
    number, // the index of the beat in the signal
    number, // Whether or not the beat should be ignored
    // for Ventricular Tachycardia episodes (0 or 1)
  ][];
}
export interface ClusterOnsetsOffsets extends ServerFile {
  meta: {
    delineation: ServerWave[];
    start: number;
  };
}

export interface ServerReclassification {
  new_wave_clusters: ServerCluster[];
}

export interface ServerChildren {
  parent_cluster: Omit<ServerCluster, 'onsets_offsets'>;
  child_cluster_id_to_wave_list: Record<string, number[][]>;
}

export interface Cluster {
  id: number;
  classification: ClusterType;
  beats: ClusterBeat[];
  priority: number;
}

export interface ClusterBeat {
  onset: number;
  offset: number;
  id: number;
  data: (number | null)[];
  previousRR?: number | null;
  nextRR?: number | null;
  currentRR?: number | null;
  // TODO: Remove hack once delin team is done
  originalOffset?: number;
}

export type ClusterType = 'PVC' | 'PAC' | 'Sinus' | 'Noise' | 'Unclassified';
export type SortingStrategy =
  | 'Time'
  | 'RR before'
  | 'RR after'
  | 'Prematurity'
  | 'Compensatory rest'
  | 'Distance to pinned beat';

// type guard of null clusters
export const isNotNullCluster = (
  cluster: Cluster | undefined,
): cluster is Cluster => cluster != null;
